/* eslint-disable */
import { ProductType } from '../language/localization';
import { Customer } from './customer';
import { PolicyStatus } from './enum/PolicyStatus';
import { PolicyStatusDefinition } from './policyStatusDefinition';
import { ProductStatusDefinition } from './ProductStatusDefinition';

export class Policy {
  id!: number;

  // Product information
  productName!: string;
  productTypeId!: number;
  productVersionCode!: string;
  productCategoryId!: number;
  productCategoryCode!: string;
  productCategoryName!: string;
  productVersion!: string;

  // Policy information
  uniqueIdentifier!: string;
  policyNumber!: string;
  contractNumber!: string;
  insuranceHolderCodeId!: string;
  insuranceGroupCodeId!: string;
  brokerCodeId!: string;
  insuranceHolderFullName!: string;

  validFromDate!: Date;
  validToDate!: Date;
  activationDate!: Date;

  grossPrice!: number;
  netPrice!:number
  discountAmount!: number;
  discountPercentage!: number;

  statusId!: number;
  subStatusId!: number;
  isSensitive!: boolean;
  isArchived!: boolean;
  summary!: ProductType;

  branchId!: number;
  createdAt!: Date;

  status!: string;
  subStatus!: string;
  brokerName!: string;
  createdByUserName!: string;

  customer!: Customer;
  isRequiredForAmendment!: boolean;

  numberOfInstallments!: number;

  policyDetails!: any;
  policyCalculationDetails!: any;

  createdBy!: string;

  constructor(data?: any) {
    if (data) {
      this.id = data.id;

      this.productName = data.productName;
      this.productCategoryCode = data.productCategoryCode;
      this.productCategoryId = data.productCategoryId;
      this.productCategoryName = data.productCategoryName;
      this.productVersion = data.productVersion;
      this.productVersionCode = data.productVersionCode;

      this.uniqueIdentifier = data.uniqueIdentifier;
      this.policyNumber = data.policyNumber;
      this.contractNumber = data.contractNumber;
      this.insuranceHolderCodeId = data.insuranceHolderCodeId;
      this.insuranceGroupCodeId = data.insuranceGroupCodeId;
      this.brokerCodeId = data.brokerCodeId;
      this.insuranceHolderFullName = data.insuranceHolderFullName;

      this.productTypeId = data.productTypeId;
      this.validFromDate = new Date(data.validFromDate);
      this.validToDate = new Date(data.validToDate);
      this.activationDate = new Date(data.activationDate);

      this.grossPrice = data.grossPrice;
      this.netPrice = data.netPrice;
      this.discountAmount = data.discountAmount;
      this.discountPercentage = data.discountPercentage;

      this.statusId = data.statusId;
      this.subStatusId = data.subStatusId;
      this.isSensitive = data.isSensitive;
      this.isArchived = data.isArchived;
      this.summary = data.summary;

      this.branchId = data.branchId;
      this.createdAt = new Date(data.createdAt);

      this.brokerName = data.brokerName;
      this.createdByUserName = data.createdByUserName;
      this.status = data.status;
      this.subStatus = data.substatus;
      this.customer = new Customer(); // TODO: CHECK IS THIS GOOD
      this.isRequiredForAmendment = data.isRequiredForAmendment;

      this.numberOfInstallments = data.numberOfInstallments;
      this.policyDetails = data.policyDetails;
      this.policyCalculationDetails = data.policyCalculationDetails;

      this.createdBy = data.createdBy;
    }
  }
}

export class PolicyWithTerminationInfo extends Policy {
  availableStatusTransitions?: PolicyStatusDefinition[];
  termination?: PolicyTerminationInfo;

  constructor(policy: Policy, availableStatusTransitions: PolicyStatusDefinition[]) {
    super();

    this.id = policy.id;
    this.productName = policy.productName;
    this.productCategoryCode = policy.productCategoryCode;
    this.productCategoryId = policy.productCategoryId;
    this.productCategoryName = policy.productCategoryName;
    this.productVersion = policy.productVersion;
    this.productVersionCode = policy.productVersionCode;
    this.uniqueIdentifier = policy.uniqueIdentifier;
    this.policyNumber = policy.policyNumber;
    this.contractNumber = policy.contractNumber;
    this.insuranceHolderCodeId = policy.insuranceHolderCodeId;
    this.insuranceGroupCodeId = policy.insuranceGroupCodeId;
    this.brokerCodeId = policy.brokerCodeId;
    this.insuranceHolderFullName = policy.insuranceHolderFullName;
    this.productTypeId = policy.productTypeId;
    this.validFromDate = policy.validFromDate;
    this.validToDate = policy.validToDate;
    this.activationDate = policy.activationDate;
    this.grossPrice = policy.grossPrice;
    this.discountAmount = policy.discountAmount;
    this.discountPercentage = policy.discountPercentage;
    this.statusId = policy.statusId;
    this.subStatusId = policy.subStatusId;
    this.isSensitive = policy.isSensitive;
    this.isArchived = policy.isArchived;
    this.summary = policy.summary;
    this.branchId = policy.branchId;
    this.createdAt = policy.createdAt;

    this.brokerName = policy.brokerName;
    this.createdByUserName = policy.createdByUserName;
    this.status = policy.status;
    this.subStatus = policy.subStatus;
    this.customer = policy.customer;
    this.isRequiredForAmendment = policy.isRequiredForAmendment;
    this.numberOfInstallments = policy.numberOfInstallments;
    this.policyDetails = policy.policyDetails;
    this.policyCalculationDetails = policy.policyCalculationDetails;

    this.availableStatusTransitions = availableStatusTransitions;
    const terminatedStatusDefinition = this.availableStatusTransitions?.find(transition => transition.id === PolicyStatus.Terminated);
    if (terminatedStatusDefinition) {
      this.termination = new PolicyTerminationInfo(terminatedStatusDefinition);
    }
  }
}

class PolicyTerminationInfo {
  dateCanBeAdjusted: boolean;
  earliestExecutionDate?: Date;
  isImmediate: boolean;
  latestExecutionDate?: Date;
  subStatusId: number;

  constructor(terminatedStatusDefinition: PolicyStatusDefinition) {
    // We always expect one substatus definition here
    let subStatusDefinition = terminatedStatusDefinition.subStatuses[0];

    this.dateCanBeAdjusted = subStatusDefinition.dateCanBeAdjusted;
    this.earliestExecutionDate = subStatusDefinition.earliestExecutionDate;
    this.isImmediate = subStatusDefinition.isImmediate;
    this.latestExecutionDate = subStatusDefinition.latestExecutionDate;
    this.subStatusId = subStatusDefinition.id;
  }
}

export class PolicyWithStatusDefinition extends Policy {
  statusDefinition: ProductStatusDefinition;

  constructor(policy: Policy, statusDefinition: ProductStatusDefinition) {
    super();

    this.id = policy.id;
    this.productName = policy.productName;
    this.productCategoryCode = policy.productCategoryCode;
    this.productCategoryId = policy.productCategoryId;
    this.productCategoryName = policy.productCategoryName;
    this.productVersion = policy.productVersion;
    this.productVersionCode = policy.productVersionCode;
    this.uniqueIdentifier = policy.uniqueIdentifier;
    this.policyNumber = policy.policyNumber;
    this.contractNumber = policy.contractNumber;
    this.insuranceHolderCodeId = policy.insuranceHolderCodeId;
    this.insuranceGroupCodeId = policy.insuranceGroupCodeId;
    this.brokerCodeId = policy.brokerCodeId;
    this.insuranceHolderFullName = policy.insuranceHolderFullName;
    this.productTypeId = policy.productTypeId;
    this.validFromDate = policy.validFromDate;
    this.validToDate = policy.validToDate;
    this.activationDate = policy.activationDate;
    this.grossPrice = policy.grossPrice;
    this.netPrice = policy.netPrice;
    this.discountAmount = policy.discountAmount;
    this.discountPercentage = policy.discountPercentage;
    this.statusId = policy.statusId;
    this.subStatusId = policy.subStatusId;
    this.isSensitive = policy.isSensitive;
    this.isArchived = policy.isArchived;
    this.summary = policy.summary;
    this.branchId = policy.branchId;
    this.createdAt = policy.createdAt;

    this.brokerName = policy.brokerName;
    this.createdByUserName = policy.createdByUserName;
    this.status = policy.status;
    this.subStatus = policy.subStatus;
    this.customer = policy.customer;
    this.isRequiredForAmendment = policy.isRequiredForAmendment;
    this.numberOfInstallments = policy.numberOfInstallments;
    this.policyDetails = policy.policyDetails;
    this.policyCalculationDetails = policy.policyCalculationDetails;

    this.statusDefinition = statusDefinition;
  }
}
